import { AwardingClient } from "@/utils/EvoClient";
import { DisableSectionsDto } from "@/utils/EvoClient/dto";

const ENDPOINT = "c/disable-sections";

export default async function DisableSections(
  dto: DisableSectionsDto
): Promise<void> {
  await AwardingClient.post(ENDPOINT, dto);
}
